import { useAuth } from '../contexts/AuthContext';
import { canPerformAction, canViewUI, canAccessRoute, Role } from '../config/permissions';

export function usePermissions() {
  const { user } = useAuth();
  const role = (user?.role || '') as Role;

  return {
    can: (action: string) => canPerformAction(role, action),
    canView: (element: string) => canViewUI(role, element),
    canAccess: (route: string) => canAccessRoute(role, route),
    role,
    isAdmin: role === 'admin',
    isManagement: role === 'management',
    isClient: role === 'client',
    isEstablishment: role === 'establishment'
  };
}

